/**
 * Handles debouncing.
 */
export default class DebounceManager {
	private debounces: { [key: string]: number } = {};

	/**
	 * Sets a debounce.
	 *
	 * @param name Name.
	 * @param callback Callback.
	 * @param timeout Timeout.
	 */
	public set(name: string, callback: () => void, timeout = 0): void {
		this.clear(name);
		this.debounces[name] = window.setTimeout(callback, timeout);
	}

	/**
	 * Checks if a debounce exists.
	 *
	 * @param name Name of debounce.
	 * @returns TRUE if debounce exists.
	 */
	public exists(name: string): boolean {
		return typeof this.debounces[name] !== 'undefined';
	}

	/**
	 * Clears a debounce.
	 *
	 * @param name Name of debounce.
	 */
	public clear(name: string): void {
		clearTimeout(this.debounces[name]);
		delete this.debounces[name];
	}

	/**
	 * Clears all debounces.
	 */
	public clearAll(): void {
		for (const name of Object.keys(this.debounces)) {
			this.clear(name);
		}
	}
}
